// log
export const configDataLoad = (payload) => {
    return {
      type: "CONFIG_DATA_LOAD",
      payload: payload,
    };
};